const setEvent = (el) => {
    const button = el.querySelector('.c-parts-color-picker__button');
    const items = el.querySelectorAll('.c-parts-color-picker__item');

    button.addEventListener('click', (e) => {
        e.stopPropagation();
        el.classList.toggle('is-active');
    });

    items.forEach((item) => {
        item.querySelector('input').addEventListener('click', (e) => {
            e.stopPropagation();
            const color = e.currentTarget.value;

            // カスタムイベントを発火
            const changeEvent = new CustomEvent('colorChange', { detail: { color } });
            el.dispatchEvent(changeEvent);
            el.classList.remove('is-active');
        });
    });
}

const main = () => {
    if (document.querySelector('.c-parts-color-picker') == null) return;

    document.querySelectorAll('.c-parts-color-picker').forEach((el) => {
        setEvent(el);
    });
}

export default main;